import { Button, Group, Text } from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { deleteBanner } from "../../../api/ApiBannerManager";

const DeleteView = ({ idItem, onSearch }: DeleteProduct) => {
  const handleDeleteBanner = async () => {
    await deleteBanner(idItem);
    modals.closeAll();
    onSearch();
  };

  return (
    <div>
      <Text size="24px">Bạn có chắc chắn muốn xóa các banner này ?</Text>
      <Group justify="center" mt="lg">
        <Button
          type="button"
          color="red"
          onClick={handleDeleteBanner}
          leftSection={<IconCheck size={18} />}
        >
          Xóa
        </Button>
        <Button
          type="button"
          color="#3598dc"
          onClick={() => modals.closeAll()}
          leftSection={<IconX size={18} />}
        >
          Hủy
        </Button>
      </Group>
    </div>
  );
};

type DeleteProduct = {
  idItem: number[];
  onSearch: () => void;
};

export default DeleteView;
